export const STORE_CURRENCY = 'EUR';

export const BANK_ACOUNT = 'ES37 2095 0276 2091 0209 2670';
